/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Vivid_Bee_WeepInputs */

const en_mild_vivid_bee_weep = /** @type {(inputs: Mild_Vivid_Bee_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No historic result IDs configured.`)
};

const de_mild_vivid_bee_weep = /** @type {(inputs: Mild_Vivid_Bee_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine historischen Ergebnis-IDs konfiguriert.`)
};

/**
* | output |
* | --- |
* | "No historic result IDs configured." |
*
* @param {Mild_Vivid_Bee_WeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_vivid_bee_weep = /** @type {((inputs?: Mild_Vivid_Bee_WeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Vivid_Bee_WeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_vivid_bee_weep(inputs)
	return de_mild_vivid_bee_weep(inputs)
});